import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navbar } from "react-bootstrap";
import {
  getAdminNavLinks,
  getSuperAdminNavLinks,
  getGeneralUserNavLinks,
  GetInstructorNavLinks,
  getCenterNavLinks,
  getPractitionerUserNavLinks,
} from "./utility";
import NavLinkList from "./NavLinkList";
import { authService } from "../../../services";
import { roles, viewPathConstants } from "../../../constants";
import {
  clearUserData,
  getCurrentUserRole,
  getLocalStorageItem,
  getSessionStorageItem,
  isShowInstructorButton,
} from "../../../system";
import { StorageKeys } from "../../../constants";
import SidebarFooter from "./SidebarFooter";
import { useNavigate } from "react-router-dom";
import routes from "../../../system/routes";
import { authActions, UserActions } from "../../../redux/actions";
import { logout } from "../../../redux/actions/auth.action";
import BecomeCertifiedPractitioner from "../../../container/views/becomeCertifiedPractitioner/BecomeCertifiedPractitioner";
import CustomModal from "../CustomModal/CustomModal";

function SideBar(props) {
  const userData = useSelector((state) => state.LoginReducer.UserData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const generalLinks = getGeneralUserNavLinks();
  const superAdminLinks = getSuperAdminNavLinks();
  const adminLinks = getAdminNavLinks();
  const instructorLinks = GetInstructorNavLinks(userData);
  const centerLinks = getCenterNavLinks(userData);
  const practitionerLinks = getPractitionerUserNavLinks();
  const userRole = getCurrentUserRole();
  const [isShow, setShow] = useState(false);

  const openModal = () => {
    setShow(true);
    dispatch(UserActions.setQualificationFormState([]));
  };

  const renderGeneralUserNavLinks = () => {
    return [...generalLinks].map((link) => renderNavLinkList(link));
  };

  const renderAdminNavLinks = () => {
    return [...adminLinks].map((link) => renderNavLinkList(link));
  };

  const renderSuperAdminNavLinks = () => {
    return [...superAdminLinks].map((link) => renderNavLinkList(link));
  };

  const renderInstructorNavLinks = () => {
    return [...instructorLinks].map((link) => renderNavLinkList(link));
  };

  const renderCenterNavLinks = () => {
    return [...centerLinks].map((link) => renderNavLinkList(link));
  };

  const renderPractionerOrVerfiedUserNavLinks = () => {
    return [...practitionerLinks].map((link) => renderNavLinkList(link));
  };

  const renderNavLinks = () => {
    const activeProfile = getLocalStorageItem(StorageKeys.activeRole);
    switch (userRole) {
      case roles.SuperAdmin:
        return renderSuperAdminNavLinks();
      case roles.Admin:
        return renderAdminNavLinks();
      case roles.GeneralUser:
        return renderGeneralUserNavLinks();
      case roles.VerifiedUser:
        return renderPractionerOrVerfiedUserNavLinks();
      case roles.Practioner:
        return renderPractionerOrVerfiedUserNavLinks();
      case roles.Instructor:
      case roles.FreelanceInstructor:
        if (activeProfile === 3) {
          return renderPractionerOrVerfiedUserNavLinks();
        } else {
          return renderInstructorNavLinks();
        }
      case roles.Center:
        return renderCenterNavLinks();
      default:
        break;
    }
  };

  function handleLogout() {
    clearUserData();
    dispatch(logout());
    window.history.replaceState(null, null, viewPathConstants.DEFAULT_PATH);
  }

  const renderNavLinkList = (...args) => {
    const [link] = args;
    return (
      <NavLinkList
        key={link.path}
        icon={link.iconPath}
        path={link.path}
        name={link.name}
        state={link?.state}
        sidebarOpen={props.sidebarOpen}
        setSideBarOpen={props.setSideBarOpen}
      />
    );
  };

  useEffect(() => {
    const storedChecked = getLocalStorageItem(StorageKeys.activeRole);
    props.setIsChecked(storedChecked === roles.Practioner);
    // eslint-disable-next-line
  }, []);

  return (
    <section className="d-flex flex-column w-100 h-100">
      {isShow && (
        <CustomModal size={"lg"} scrollable show={isShow} setShow={setShow}>
          <BecomeCertifiedPractitioner
            isInstructor={true}
            onSetShow={setShow}
          />
        </CustomModal>
      )}
      <section className="overflow-y-auto">
        <Navbar
          expand="md"
          expanded
          className="flex-column pb-0 mb-1 justify-content-start px-0"
          variant="light"
        >
          <section className="mt-1 justify-content-start nav-menu-wrapper w-100">
            {(() => renderNavLinks())()}
          </section>
        </Navbar>
      </section>

      <SidebarFooter
        userRole={userRole}
        roles={roles}
        userData={userData}
        isChecked={props.isChecked}
        sidebarOpen={props.sidebarOpen}
        isShowInstructorButton={isShowInstructorButton}
        handleProfileToggle={props.handleProfileToggle}
        openModal={openModal}
        handleLogout={handleLogout}
      />
    </section>
  );
}

export default SideBar;
